import { ArchitectureDiagramConfig } from '../types/appShowcase';

export const kubesentryDiagram: ArchitectureDiagramConfig = {
  viewBox: '0 0 880 1400',
  boxes: [
    {
      x: 290,
      y: 16,
      w: 300,
      h: 52,
      label: 'Kubernetes Cluster',
      sublabel: 'kind / EKS',
      fill: 'rgba(0,166,153,0.35)',
    },
    {
      x: 50,
      y: 108,
      w: 220,
      h: 108,
      label: 'Kubernetes API',
      lines: ['List Pods', 'Describe Pod', 'Logs + Events'],
      fill: 'rgba(0,0,0,0.45)',
    },
    {
      x: 610,
      y: 108,
      w: 220,
      h: 108,
      label: 'Prometheus / Metrics',
      lines: ['CloudWatch', 'Logs', 'Alerts'],
      fill: 'rgba(0,0,0,0.25)',
    },
    {
      x: 240,
      y: 268,
      w: 400,
      h: 118,
      label: 'Worker + Detector',
      lines: ['Poll every 30s', 'CrashLoopBackOff', 'ImagePullBackOff', 'PendingTooLong + PodFailed'],
      fill: 'rgba(255,90,95,0.35)',
    },
    {
      x: 200,
      y: 426,
      w: 480,
      h: 118,
      label: 'Go Agent Graph',
      lines: ['Nodes + conditional edges', 'MCP tools', 'Incident State', 'Single Bedrock RCA'],
      fill: 'rgba(255,90,95,0.25)',
    },
    {
      x: 50,
      y: 582,
      w: 240,
      h: 100,
      label: 'Kubernetes Tools',
      lines: ['MCP: DescribePod', 'GetPodLogs', 'ListEvents'],
      fill: 'rgba(0,0,0,0.45)',
    },
    {
      x: 590,
      y: 582,
      w: 240,
      h: 100,
      label: 'Web Search (planned)',
      lines: ['AWS Docs', 'CVEs', 'Kubernetes Docs'],
      fill: 'rgba(0,0,0,0.25)',
    },
    {
      x: 240,
      y: 722,
      w: 400,
      h: 88,
      label: 'Amazon Bedrock',
      lines: ['Claude Sonnet 4', 'One prompt per incident'],
      fill: 'rgba(0,166,153,0.35)',
    },
    {
      x: 200,
      y: 842,
      w: 480,
      h: 100,
      label: 'Root Cause Analysis',
      lines: ['Confidence Score', 'Suggested Remediation', 'kubectl / YAML Recommendations'],
      fill: 'rgba(255,90,95,0.35)',
    },
    {
      x: 120,
      y: 978,
      w: 640,
      h: 56,
      label: 'HTTP API + S3 Alert Store · Slack / Jira / Dashboard (planned)',
      fill: 'rgba(0,166,153,0.25)',
    },
    {
      x: 160,
      y: 1068,
      w: 560,
      h: 40,
      label: 'Chaos Engineering / Validation Pipeline (planned)',
      fill: 'rgba(255,180,50,0.3)',
    },
    {
      x: 200,
      y: 1132,
      w: 480,
      h: 52,
      label: 'LitmusChaos / Chaos Mesh / AWS FIS',
      fill: 'rgba(255,180,50,0.25)',
    },
    {
      x: 200,
      y: 1210,
      w: 480,
      h: 100,
      label: 'Inject Failures',
      lines: ['Pod Failures', 'Kill Nodes', 'Network Latency', 'CPU / Memory Pressure'],
      fill: 'rgba(255,180,50,0.2)',
    },
    {
      x: 240,
      y: 1338,
      w: 400,
      h: 52,
      label: 'Verify KubeSentry',
      sublabel: 'Detects & diagnoses correctly',
      fill: 'rgba(255,180,50,0.35)',
    },
  ],
  arrows: [
    { x1: 440, y1: 68, x2: 160, y2: 106 },
    { x1: 440, y1: 68, x2: 720, y2: 106 },
    { x1: 160, y1: 216, x2: 340, y2: 266 },
    { x1: 720, y1: 216, x2: 540, y2: 266 },
    { x1: 440, y1: 386, x2: 440, y2: 424 },
    { x1: 170, y1: 582, x2: 300, y2: 544 },
    { x1: 710, y1: 582, x2: 580, y2: 544 },
    { x1: 440, y1: 544, x2: 440, y2: 720 },
    { x1: 440, y1: 810, x2: 440, y2: 840 },
    { x1: 440, y1: 942, x2: 440, y2: 976 },
    { x1: 440, y1: 1034, x2: 440, y2: 1066 },
    { x1: 440, y1: 1108, x2: 440, y2: 1130 },
    { x1: 440, y1: 1184, x2: 440, y2: 1208 },
    { x1: 440, y1: 1310, x2: 440, y2: 1336 },
  ],
  footer: 'Go worker polls the cluster, plans evidence gathering, and calls Bedrock once per incident ? chaos validation planned',
};
